import { AuthContext } from "../contexts/AuthContext";
import { useContext, useState } from "react";
import { useLocation, Link } from "react-router-dom";

export default function NavBar() {
  const { user_data, logout } = useContext(AuthContext);
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  const isOnboarding = location.pathname === "/onboarding";

  const handleCopy = () => {
    if (!user_data?.client_unique_account_id) return;
    navigator.clipboard.writeText(user_data.client_unique_account_id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // reset after 2s
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        {/* Brand logo */}
        <Link className="navbar-brand" to="/">
          <img
            src="/other_images/fc_simple_logo.png"
            style={{ width: "30px" }}
            alt="FinaCraft Logo"
            className="rounded-pill"
          />
        </Link>

        <ul className="navbar-nav">
          {isOnboarding ? (
            <li className="nav-item">
              <Link
                className={`nav-link ${location.pathname === "/onboarding" ? "active" : ""}`}
                to="/onboarding"
              >
                Onboarding
              </Link>
            </li>
          ) : (
            <>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/dashboard" ? "active" : ""}`}
                  to="/dashboard"
                >
                  Dashboard
                </Link>
              </li>
            </>
          )}
        </ul>

        {/* Profile picture dropdown */}
        <div className="dropdown ms-auto">
          <button
            className="btn btn-dark dropdown-toggle"
            type="button"
            id="profileDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={
                user_data?.profile_picture ||
                "https://www.gravatar.com/avatar/HASH?d=identicon"
              }
              alt="Profile Picture"
              style={{ width: "30px" }}
              className="rounded-pill"
            />
          </button>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
            <li className="dropdown-item">
              Welcome <strong>{user_data?.backend_user.first_name} {user_data?.backend_user.last_name}</strong>
            </li>

            {/* Client ID with masked display + copy button */}
            <li className="dropdown-item text-muted d-flex justify-content-between align-items-center">
              <span>Client ID: ••••••</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleCopy}
                title={copied ? "Copied!" : "Copy to clipboard"}
              >
                📋
              </button>
            </li>

            <li className="dropdown-item text-muted">
              Email: {user_data?.backend_user.email}
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button className="dropdown-item text-danger" onClick={logout}>
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
